import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { DeliveryActivityItem } from '../models/delivery-activity.models';

@Component({
  selector: 'delivery-block',
  standalone: true,
  imports: [DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './delivery-block.component.html',
  styleUrls: ['./delivery-block.component.scss'],
})
export class DeliveryBlockComponent {
  readonly delivery = input.required<DeliveryActivityItem>();
  readonly color = input.required<string>();

  readonly blockClick = output<DeliveryActivityItem>();

  protected readonly tooltip = computed(() => {
    const d = this.delivery();
    const lines: string[] = [
      `${d.equipmentLabel}  ·  ${d.operatorLabel}`,
      `Date: ${d.date}`,
      `Loaded: ${d.loadedKg.toFixed(0)} kg`,
      `Holes loaded: ${d.holeCount ?? 0}`,
    ];
    return lines.join('\n');
  });
}
